import { render } from "./nazar.vue?vue&type=template&id=09680748"
import script from "./nazar.vue?vue&type=script&lang=js"
export * from "./nazar.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/ringpiston-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__